export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
